import { QueryResultT } from '@core/types/query-result-t';
import { Entity, EntityManager, EntityQuery } from 'breeze-client';

export class EntityManagerHelper {
  public constructor(private em: EntityManager) {}
  public async executeQuery<T = Entity>(query: EntityQuery) {
    return (await this.em.executeQuery(query)) as QueryResultT<T>;
  }
}
